import { render } from "./BFormSelectOption.vue?vue&type=template&id=5c9f652e&ts=true"
import script from "./BFormSelectOption.vue?vue&type=script&lang=ts"
export * from "./BFormSelectOption.vue?vue&type=script&lang=ts"

import exportComponent from "/var/lib/jenkins/workspace/Momentum/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__